import { render, staticRenderFns } from "./savedQuoteThankYou.vue?vue&type=template&id=77f4fafe&scoped=true"
import script from "./savedQuoteThankYou.vue?vue&type=script&lang=js"
export * from "./savedQuoteThankYou.vue?vue&type=script&lang=js"
import style0 from "./savedQuoteThankYou.vue?vue&type=style&index=0&id=77f4fafe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f4fafe",
  null
  
)

export default component.exports